import { render, staticRenderFns } from "./OrgManagement.vue?vue&type=template&id=221aedfc&scoped=true&"
import script from "./OrgManagement.vue?vue&type=script&lang=js&"
export * from "./OrgManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrgManagement.vue?vue&type=style&index=0&id=221aedfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221aedfc",
  null
  
)

export default component.exports